var _generateQueryMap;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* eslint-disable no-console */

import i18next from 'i18next';
import { useTranslation as useOriginTranslation } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { DevelopmentKeys, StgKeys, PrevKeys, ProductionKeys } from '../constants';
import { generateQueryMap } from './tool';
var DEFAULT_LANG = 'en';
var defaultNamespace = 'default';
var cdnDomain = 'https://cdn.myshopline.com/t/i18n/ec-settlement';
var i18n = i18next.createInstance();
var envMap = generateQueryMap((_generateQueryMap = {}, _defineProperty(_generateQueryMap, DevelopmentKeys.join('|'), 'stg'), _defineProperty(_generateQueryMap, StgKeys.join('|'), 'stg'), _defineProperty(_generateQueryMap, PrevKeys.join('|'), 'prev'), _defineProperty(_generateQueryMap, ProductionKeys.join('|'), 'prod'), _generateQueryMap));
var initI18n = function initI18n(env, currentLang) {
  // 如果实例已经init完成时
  if (i18n.isInitialized) return Promise.resolve(i18n.t);
  var defaultLang = currentLang || DEFAULT_LANG;
  return i18n.use(HttpApi).init({
    /**
     * 配置 i18n
     * https://www.i18next.com/overview/configuration-options
     */
    debug: false,
    load: 'currentOnly',
    lng: defaultLang,
    fallbackLng: defaultLang,
    preload: [defaultLang],
    ns: [defaultNamespace],
    defaultNS: defaultNamespace,
    parseMissingKeyHandler: function parseMissingKeyHandler(key) {
      return "*".concat(key, "*");
    },
    keySeparator: false,
    interpolation: {
      prefix: '{',
      suffix: '}',
      escapeValue: false
    },
    /**
     * 配置 i18next-http-backend
     * https://github.com/i18next/i18next-http-backend#backend-options
     */
    backend: {
      loadPath: "".concat(cdnDomain, "/").concat(envMap[env] || 'prod', "/{lng}.raw.json"),
      crossDomain: true
    },
    /**
     * 配置 react-i18next
     * https://react.i18next.com/latest/i18next-instance
     */
    react: {
      useSuspense: false
    },
    lowerCaseLng: true
  });
};
export function useTranslation() {
  return useOriginTranslation('default', {
    i18n: i18n
  });
}
export function safeTranslate(t, key, defaults) {
  var translated = t(key);
  if (typeof translated === 'string' && translated.includes(key)) {
    return defaults;
  }
  return translated;
}
export default i18n;
export { initI18n };